'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  search: {
    placeholder: 'Search'
  },
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'TEST DRIVE',
    classes: 'btn-ghost hidden-xs gold',
    link: '/en-us/free-trial'
  }, {
    text: 'LOGIN',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/expense-management'
      }, {
        text: 'Concur Detect by AppZen',
        src: '/detect-expense-fraud'
      }, {
        text: 'Concur Drive',
        src: '/concur-drive'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }, {
        text: 'Travel & Expense',
        src: '/travel-expense'
      }]
    }, {
      text: 'Travel products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Travel',
        src: '/travel-booking'
      }, {
        text: 'Concur Locate',
        src: '/concur-locate'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }, {
        text: 'TripLink Connected Suppliers',
        src: '/triplink-supplier-connections'
      }, {
        text: 'Triplink Travel Organizations',
        src: '/triplink-travel-organization'
      }]
    }, {
      text: 'Invoice products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Invoice',
        src: '/invoice-management'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }]
    }, {
      text: 'Data insights',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Analytics',
        src: '/analytics'
      }, {
        text: 'Intelligence',
        src: '/business-intelligence'
      }]
    }, {
      text: 'Support Offerings',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Service Administration',
        src: '/extended-services/service-administration'
      }]
    }, {
      text: 'Integrations',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'SAP',
        src: '/sap-integration'
      }, {
        text: 'Platform',
        src: '/concur-integrated-ecosystem'
      }, {
        text: 'Concur TripLink',
        src: '/triplink'
      }, {
        text: 'App Center',
        src: '/app-centre'
      }]
    }, {
      text: 'Test Drive',
      src: '/free-trial',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOLUTIONS'
    },
    list: [{
      text: 'For small business',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/small-business/expense'
      }, {
        text: 'Concur Invoice',
        src: '/small-business/invoice'
      }, {
        text: 'Concur Travel',
        src: '/triplink'
      }, {
        text: 'All solutions',
        src: '/small-business'
      }]
    }, {
      text: 'For public sector',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Public Sector',
        src: '/public-sector'
      }]
    }, {
      text: 'By business need',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'AP Automation',
        src: '/ap-automation'
      }, {
        text: 'FBT reporting',
        src: '/fringe-benefit-tax'
      }, {
        text: 'Visibility and compliance',
        src: '/visibility-and-compliance'
      }]
    }, {
      text: 'By industry',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Financial services',
        src: '/financial-services'
      }, {
        text: 'Retail and restaurant',
        src: '/retail'
      }, {
        text: 'Energy and natural resources',
        src: '/energy-natural-resources'
      }]
    }, {
      text: 'By role',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Enterprise Finance Leader',
        src: '/financial-manager-solutions'
      }, {
        text: 'IT Leader',
        src: '/it-leader'
      }]
    }, {
      text: 'Request a quote',
      src: '/get-quote-form',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Why SAP Concur',
      src: '/why-concur'
    }, {
      text: 'Our Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'Locations',
      src: '/contact/offices'
    }, {
      text: 'Careers',
      src: '/en-us/careers'
    }, {
      text: 'CONTACT SALES',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Resource Center',
      src: '/resource-centre'
    }, {
      text: 'Events',
      src: '/events'
    }, {
      text: 'Case Studies',
      src: '/casestudy/index'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'App Center',
      src: '/app-centre'
    }, {
      text: 'Request a quote',
      src: '/get-quote-form'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }, {
      text: 'Expense Demo',
      src: '/self-guided-demo-expense',
      classes: 'call-out'
    }, {
      text: 'Invoice Demo',
      src: '/self-guided-demo-invoice',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: ''
  }, {
    text: 'CONTACT',
    href: '/contact'
  }, {
    text: 'LOGIN',
    href: ''
  }, {
    text: 'REQUEST A QUOTE',
    href: '/get-quote-form'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};